export const TEST_ID = 'shapefilePreview';

export const WGS84_CHECK_MARK = '\u2713';

export const SQ_METERS_PER_HECTARE = 10000;

export const MIN_RING_POINTS = 3;

export const EARTH_RADIUS_METERS = 6378137;
